import React from 'react'
import { Button, Modal } from 'react-bootstrap'
import { Auth } from 'aws-amplify'
import ModifyContentPoints from '../../Services/Mutations/ModifyContentPoints'
import DateTimePicker from 'react-datetime-picker'
import { heightPercentageToDP } from '../../Utils/ResponsiveScreen'
class NewOnTop extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			modalVisible: false,
			newsOnTopFor: '4 Hours',
			selectedCustomNewstime: new Date(),
			rank: '',
		}
	}
	openModal = () => {
		this.setState({ modalVisible: true })
	}
	closeModal = () => {
		this.setState({
			newsOnTopFor: '4 Hours',
			modalVisible: false,
			selectedCustomNewstime: new Date(),
			showDateTimePicker: false,
			rank: '',
		})
	}

	handleNewsOnTopOption = (value) => {
		if (value != 'custom') {
			this.setState({
				newsOnTopFor: value,
				showDateTimePicker: false,
			})
		}
		this.setState({ newsOnTopFor: value })
	}
	handleRank = (e) => {
		const rank = e.target.value

		this.setState({ rank: rank })
	}
	handleMakeContentOnTop = async (videoInfo) => {
		const { newsOnTopFor, selectedCustomNewstime } = this.state
		const customNewsTimeInEpochInSeconds = selectedCustomNewstime.getTime() / 1000
		let loggedInUserHandle = ''
		const loggedInUserEmail = Auth.user.attributes ? Auth.user.attributes.email : ''
		if (loggedInUserEmail) {
			const emailParams = loggedInUserEmail.split('@')
			loggedInUserHandle = '@' + emailParams[0]
		}
		const parameters = {
			contentID: this.props.item.PK,
			newsOnTopFor: newsOnTopFor,
			ModeratorID: Auth.user.username,
			moderatorHandle: loggedInUserHandle,
		}
		if (newsOnTopFor == 'rank') {
			parameters.rank = parseInt(this.state.rank)
		}
		if (newsOnTopFor == 'custom') {
			parameters['customNewsTime'] = parseInt(customNewsTimeInEpochInSeconds)
		}
		console.log(parameters, 'parameters===')
		try {
			const response = await ModifyContentPoints(parameters)
			console.log(response, 'responseeeeeeeeeeee=============')

			if (response.statusCode == 'A261') {
				this.props.displayToast('success', 'Added Content On Top Successfully')
			} else {
				this.props.displayToast('error', 'Failed to add content on top')
			}
		} catch (error) {
			return error
		}

		this.setState({
			rank: '',
			newsOnTopFor: '4 Hours',
			modalVisible: false,
			selectedCustomNewstime: new Date(),
			showDateTimePicker: false,
		})
	}

	render() {
		const { modalVisible, newsOnTopFor } = this.state
		let currentDate1 = new Date()
		let currentDate2 = new Date()
		let minDate = new Date(currentDate1.setDate(currentDate1.getDate() - 15))
		let maxDate = new Date(currentDate2.setDate(currentDate2.getDate() + 15))

		return (
			<>
				{this.props.rank ? (
					<div
						class={this.props.rank ? '' : 'col-md-3 faIconClass'}
						onClick={() => {
							this.openModal()
						}}
					>
						<label>News On Top</label>
					</div>
				) : (
					<div

						data-toggle='tooltip'
						title={`News On Top`}
						style={{ fontSize: '12px' }}
						class={this.props.rank ? '' : 'col-md-3 faIconClass'}
						onClick={() => {
							this.openModal()
						}}
					>
						<i class='fas fa-arrow-up fa-lg' />
					</div>
				)}
				<Modal show={modalVisible} onHide={() => this.closeModal()}>
					<Modal.Body>
						<div className='row'>
							<text>Make This News On Top For</text>

							<div class='col-md-3'>
								<input
									value={newsOnTopFor}
									type='radio'
									checked={newsOnTopFor == '4 Hours'}
									onClick={() => {
										this.handleNewsOnTopOption('4 Hours')
									}}
								></input>
								<text for={'4 Hours'}>{'4 Hours'}</text>
							</div>
							<div class='col-md-3'>
								<input
									value={newsOnTopFor}
									type='radio'
									checked={newsOnTopFor == '8 Hours'}
									onClick={() => {
										this.handleNewsOnTopOption('8 Hours')
									}}
								></input>
								<text for={'8 Hours'}>{'8 Hours'}</text>
							</div>
							<div class='col-md-3'>
								<input
									value={newsOnTopFor}
									type='radio'
									checked={newsOnTopFor == '12 Hours'}
									onClick={() => {
										this.handleNewsOnTopOption('12 Hours')
									}}
								></input>
								<text for={'12 Hours'}>{'12 Hours'}</text>
							</div>
							<div class='col-md-3'>
								<input
									value={newsOnTopFor}
									type='radio'
									checked={newsOnTopFor == '24 Hours'}
									onClick={() => {
										this.handleNewsOnTopOption('24 Hours')
									}}
								></input>
								<text for={'24 Hours'}>{'24 Hours'}</text>
							</div>
							<div class='col-md-3'>
								<input
									value={newsOnTopFor}
									type='radio'
									checked={newsOnTopFor == 'rank'}
									onClick={() => {
										this.handleNewsOnTopOption('rank')
									}}
								></input>
								<text for={'rank'}>{'Rank'}</text>
							</div>
							<div class='col-md-3'>
								<input
									value={newsOnTopFor}
									type='radio'
									checked={newsOnTopFor == 'custom'}
									onClick={() => {
										this.handleNewsOnTopOption('custom')
										this.setState({
											showDateTimePicker: true,
										})
									}}
								></input>
								<text for={'custom'}>{'custom'}</text>
								{this.state.customNewsTime ? (
									<text>{` : ${this.state.customNewsTime}`}</text>
								) : null}
							</div>
							{this.state.showDateTimePicker ? (
								<div style={{ height: heightPercentageToDP('30') }}>
									<DateTimePicker
										onChange={(val) => {
											this.setState({ selectedCustomNewstime: val })
										}}
										value={this.state.selectedCustomNewstime}
										isClockOpen={false}
										disableClock={true}
										maxDetail='second'
										maxDate={maxDate}
										minDate={minDate}
									/>
								</div>
							) : null}
							{newsOnTopFor == 'rank' ? (
								<div>
									<text for='text'>Rank</text>
									<div>
										<input
											type='number'
											onChange={(value) => {
												this.handleRank(value)
											}}
											value={this.state.rank}
											placeholder='Please Enter Rank'
										></input>
									</div>
									{this.state.rank > 100 ? (
										<text for='text' style={{ color: 'red', fontSize: 10 }}>
											Rank cannot be greater than 100
										</text>
									) : null}
								</div>
							) : null}
						</div>
					</Modal.Body>
					<Modal.Footer>
						<Button onClick={() => this.closeModal()}>Cancel</Button>
						{newsOnTopFor == 'rank' && (this.state.rank == '' || this.state.rank > 100) ? (
							<Button disabled variant='primary'>
								Ok
							</Button>
						) : (
							<Button onClick={() => this.handleMakeContentOnTop()}>Ok</Button>
						)}
					</Modal.Footer>
				</Modal>
			</>
		)
	}
}

export default NewOnTop
